import React from 'react';
import { AddParentAdminController } from './AddParentAdminController/AddParentAdminController';
import { useCanAccessParentAdminFlows } from './hooks/useCanAccessParentAdminFlows/useCanAccessParentAdminFlows';

export const AddParentAdmin: React.FC = () => {
  const isUserAllowedAccess = useCanAccessParentAdminFlows();

  if (!isUserAllowedAccess) {
    return null;
  }

  return <AddParentAdminController />;
};
